import loginSignupDialog from './loginSignupDialog';

export default {
  loginSignupDialog
};
